import { OrgUsersVCSUserData } from '@/types';
import { UPDATE_ORG_USERS_VCS_USER_DATA, TryUpdateOrgUsersVCSUserData } from '@/actions/orgUsersVCSUserData';

export function orgUsersVCSUserData(
    state: OrgUsersVCSUserData = {},
    action: TryUpdateOrgUsersVCSUserData,
): OrgUsersVCSUserData {
    switch (action.type) {
        case UPDATE_ORG_USERS_VCS_USER_DATA: {
            return action.payload ?? {};
        }

        default:
            return state;
    }
}
